module.exports = __webpack_public_path__ + "static/img/5.f8be5a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/eng/5.png
// module id = Vz+o
// module chunks = 0